import { createRoute } from '@tanstack/react-router';
import { adminParentRoute } from 'pages/admin/adminParentRoute';
import { pageResetMiddleWare, zodOptionalId, zodPage } from 'routes/routeUtils';
import { z } from 'zod';

export const adminPaymentsRoute = createRoute({
  getParentRoute: () => adminParentRoute,
  path: '/payments',
  validateSearch: z.object({
    page: zodPage,
    tab: z
      .enum(['mass_payments', 'beneficiary_payments', 'incoming_payments', 'refund_requests'])
      .default('mass_payments'),
    massPaymentId: zodOptionalId,
  }),
  search: { middlewares: [pageResetMiddleWare] },
}).lazy(() =>
  import('pages/admin/Payments/AdminPaymentsPage/AdminPaymentsPage').then((d) => d.Route)
);
